/**
 * Hooks to access Privy authentication
 */

import { useContext } from "react";
import { PrivyAuthContext, type PrivyAuthContextValue } from "./privy-auth-provider";

/**
 * Hook to access Privy authentication state and methods.
 */
export function usePrivyAuth(): PrivyAuthContextValue {
  const context = useContext(PrivyAuthContext);
  if (!context) {
    // Return a default context if Privy is not configured
    return {
      ready: true,
      authenticated: false,
      user: null,
      solanaWalletAddress: null,
      backendToken: null,
      userId: null,
      loginMethod: null,
      isNewUser: false,
      login: () => {
        console.warn("[PrivyAuth] Privy not configured");
      },
      logout: async () => {
        console.warn("[PrivyAuth] Privy not configured");
      },
      fundWallet: async () => {
        console.warn("[PrivyAuth] Privy not configured");
      },
      exportWallet: async () => {
        console.warn("[PrivyAuth] Privy not configured");
      },
    };
  }
  return context;
}

/**
 * Hook to check if user is authenticated via Privy.
 */
export function useIsPrivyAuthenticated(): boolean {
  const context = useContext(PrivyAuthContext);
  return context?.authenticated ?? false;
}

